import {Component, OnDestroy, OnInit, VERSION} from "@angular/core";
import {Compbaser} from "../../components/compbaser";
import {AccessService, StoreSelectorsService} from "../../services";
import {EnumStudioType, IAppStatic, IUser} from "../../interfaces";
import {Router} from "@angular/router";
import {map, take} from "rxjs/operators";
import {compareIds, DEFAULT_PORT, isNullOrUndefOrEmpty, WEB_SERVER} from "../../common";
import {faEdit} from "@fortawesome/free-solid-svg-icons";

const {version: appVersion} = require('../../../../package.json');
const {cloudVersion: cloudVersion} = require('../../../../package.json');

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent extends Compbaser implements OnInit, OnDestroy {

    protected readonly faEdit = faEdit;
    protected readonly EnumStudioType = EnumStudioType;
    studioType: EnumStudioType;
    enterpriseMode: boolean;
    dashboardMode: boolean;
    uiMode;
    appVersion = appVersion;
    cloudVersion = cloudVersion;
    version = VERSION.full;
    embedCustomHomePage;
    user: IUser;
    appSettings: IAppStatic;

    constructor(private router: Router, private storeSelector: StoreSelectorsService, private accessService: AccessService) {
        super();
        this.setUiMode(0);
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                })
        )
        this.cod(
            this.storeSelector.getUser().subscribe((i_user) => {
                this.user = i_user;
                this.checkEmbeddedCustomHomePage();
            })
        );
    }

    ngOnInit(): void {
        this.cod(
            this.storeSelector.getUser().subscribe((i_user) => {
                this.user = i_user;
                this.studioType = i_user.studioType;
                this.enterpriseMode = i_user.enterprise;
                this.dashboardMode = i_user.dashboard;
                if (this.dashboardMode) {
                    this.uiMode = 1;
                    this.router.navigateByUrl('/statistics');
                } else if (this.studioType === EnumStudioType.LITE || this.studioType === EnumStudioType.PRO) {
                    this.setUiMode(2);
                } else {
                    this.setUiMode(3);
                }
            })
        );
    }

    private setUiMode(v) {
        /** never override 4, custom HTML enterprise home page **/
        // if (this.uiMode === 4) return;
        // console.log('loading home mode ' + v);
        this.uiMode = v;
    }

    /** if enterprise user check if we need to swap overview page to a custom home page **/
    private checkEmbeddedCustomHomePage() {
        if (!this.user.enterprise) return;
        this.cod(
            this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value))
                .pipe(take(1),
                    map((value) => {
                        return value?.$?.showCustomHome ? value.$.showCustomHome : '0';
                    })
                ).subscribe((v) => {
                if (compareIds(v, '1') && !isNullOrUndefOrEmpty(this.user.customStudio?.Studio?.Application?.[0]?.Links?.[0]?.$?.download)) {
                    if (this.user.customStudio.Studio.Application[0].Links[0].$.download.indexOf('http') === -1) return;
                    const b64 = btoa(this.user.customStudio.Studio.Application[0].Links[0].$.download);
                    this.embedCustomHomePage = `${WEB_SERVER}:${DEFAULT_PORT}/proxyRequest/${b64}`;
                    if (this.embedCustomHomePage) {
                        this.setUiMode(4);
                    }
                }
            })
        );
    }


    download(value) {
        window.location.replace(this.appSettings.studioLiteLegacy);

    }
}


